// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.css';
import router from './router'
import store from './store/index';
import moment from 'moment';
import { toExcel } from '@/excel/json2excel'
Vue.use(ElementUI);

import VueClipBoard from 'vue-clipboard2';
Vue.use(VueClipBoard);

Vue.config.productionTip = false;
import './assets/styles/base.css';
import './assets/styles/element_base.css';
import './assets/styles/ql_editor.css';
// 富文本编辑器UI
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.prototype.$devType = process.env.NODE_ENV; // 环境类型
Vue.prototype.$imgHeader = process.env.NODE_ENV !== 'testing' ? '' : '/supply/backend/';

import qs from 'qs';
Vue.prototype.qs = qs;
// 全局方法
import commonFun from './until/common.js';
Vue.prototype.$f = commonFun;
Vue.prototype.$i18nF = commonFun.i18nF;
import { message } from './until/resetMessage.js';
Vue.prototype.$message = message;
Vue.prototype.$toExcel = toExcel;
import './until/directives';

// 引入全局提示框
import toastRegistry from './components/toast/toast.js';
Vue.use(toastRegistry);

// 引入公共组件
import Default from './components/default';
Vue.component('Default', Default);

import copyValue from '@/components/common/copyValue';
Vue.component('copyValue', copyValue);

import clickCopy from './components/common/clickCopy';
Vue.component('clickCopy', clickCopy);

import aLineInfo from '@/components/common/aLineInfo';
Vue.component('aLineInfo', aLineInfo);

import orderState from '@/components/order/orderState';
Vue.component('orderState', orderState);

import './until/axios';

import {
  i18n
} from './until/vue-i18n';
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

Vue.filter('moment', (a) => {
  return a ? moment(a).format('YYYY-MM-DD HH:mm:ss') : '-'
})

Vue.filter('YMD', (a) => {
  return a ? moment(a).format('YYYY-MM-DD') : '-'
})
const user = window.sessionStorage.getItem('user');
if (user) {
  store.commit('GET_USER_INFO', user);
}

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js